import React from "react";
import { Component } from "react";
import icon_type_date from "../../Assets/svg/icon_type_date.svg";
import format_date_formal from "../../App/validation/format_date_formal";
import is_not_empty from "../../App/validation/is_not_empty";

export default class DateCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: "",
    };
    this.dateInputRef = React.createRef();
  }

  componentDidMount = () => {
    const { params } = this.props;
    this.setState({
      date: is_not_empty(params?.value) ? params?.value : "",
    });
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.params?.value !== prevProps?.params?.value) {
      this.setState({
        date: is_not_empty(this.props.params?.value)
          ? this.props.params?.value
          : "",
      });
    }
  };

  handle_submit = () => {
    let newParams = this.props.params;
    newParams.value = this.state.date;
    newParams.row.value = this.state.date;

    this.props.handleEditCellChange(
      this.props.editProperties,
      this.props.layer_id,
      newParams
    );
  };

  handle_change = (e) => {
    this.setState(
      {
        date: e.target?.value,
      },
      () => {
        this.handle_submit();
      }
    );
  };

  // Focus the input to trigger Firefox date picker
  handle_button_click = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.dateInputRef.current) {
      // For Firefox, we need to focus the input
      this.dateInputRef.current.focus();
      // Try showPicker if available (Chrome/Edge)
      if (typeof this.dateInputRef.current.showPicker === "function") {
        try {
          this.dateInputRef.current.showPicker();
        } catch (err) {
          // Fallback if showPicker fails
          this.dateInputRef.current.click();
        }
      } else {
        // Firefox fallback - click the input
        this.dateInputRef.current.click();
      }
    }
  };

  toggle_mode_edit = () => {
    const { is_mode_edit } = this.state;
    this.setState({
      is_mode_edit: !is_mode_edit,
    });
  };

  render() {
    const { params } = this.props;
    const { date } = this.state;
    const converted_date = date ? format_date_formal(date) : "";

    const buttonStyle = {
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
    };

    const inputStyle = {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0,
      cursor: "pointer",
      zIndex: 2,
      border: "none",
      background: "transparent",
    };

    return (
      <main className="center_perfect w_full">
        <div className="w_full h_full flex justify_between">
          <span title="DD-MM-YYYY">{converted_date}</span>
          <button
            type="button"
            className="datepicker-native-button bg_grey rounded_5 pointer button_inactive"
            onClick={this.handle_button_click}
            style={buttonStyle}
            tabIndex={-1}
          >
            <img
              alt="date"
              src={icon_type_date}
              className="w_15 h_15"
              style={{ pointerEvents: "none", position: "relative", zIndex: 1 }}
            />
            <input
              ref={this.dateInputRef}
              id={`date-${params?.field}`}
              className="datepicker-native-button-input"
              value={date || ""}
              type="date"
              onChange={this.handle_change}
              style={inputStyle}
              tabIndex={0}
            />
          </button>
        </div>
      </main>
    );
  }
}
